import { WrapperFooter, WrapperFooterContent, ContainerFooterContent } from '../../styles';
import { ReactComponent as LogoDanielBranca } from 'assets/images/logo.svg';
import { Text, Divider } from '@chakra-ui/react';
import { colors } from 'theme/colors';

export const Footer = () => {
  return (
    <WrapperFooter>
      <LogoDanielBranca />
      <WrapperFooterContent>
        <ContainerFooterContent>
          <Text>SÃO PAULO</Text>
          <address>
            Rua Leopoldo Couto Magalhães Júnior, 785,5º andar, Conjunto 52 <br />
            (Edifício New Century) - Itaim Bibi - CEP:04542-000 <br />
            Tel.: (55 11) 2103.9107 | Tel/Fax: (55 11) 2103.9124
          </address>
        </ContainerFooterContent>
        <ContainerFooterContent>
          <Text>RIO DE JANEIRO</Text>
          <address>
            Avenida República do Chile. 330/21º andar <br />
            Centro - CEP: 20.031-170
            <br />
            Tel.: (55 21) 2102.4212 | Fax: (55 21) 2524.3344
          </address>
        </ContainerFooterContent>
      </WrapperFooterContent>

      <Divider borderColor={colors.brand.tertiary} border="1px" mb="3rem" />

      <p className="copyRight">
        © Copyright 2020-{new Date().getFullYear()} - Daniel Law. All rights reserved.
      </p>
      <p className="terms">
        I have read and accept Daniel Law
        <a
          href="https://www.daniel-ip.com/en/terms-of-use-and-privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {' '}
          Terms of Use and Privacy Policy.
        </a>
      </p>
      {/* {location.href.includes('dpo-hub.daniel-ip.com') ? (
        <p style={{ color: 'black' }}>Ambiente de {process.env.NODE_ENV}</p>
      ) : (
        <p style={{ color: 'black' }}>Ambiente de {process.env.NODE_ENV}</p>
      )} */}
    </WrapperFooter>
  );
};
